// This is used for some reason to help with signalr, apparently it
// searches for this specific cookie in order to pull a token for auth.
// Nick understands the details of why.

const setAuthCookie = (token) => {
  document.cookie = `access_token=${token};path=/`;
};

// Example from https://www.w3schools.com/js/js_cookies.asp
const clearAuthCookie = () => {
  document.cookie = `access_token=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`;
};

export { setAuthCookie, clearAuthCookie };
